import { TranscriptEntry } from '../../../platform-call';
import { PayloadAction } from '../../../store.model';
import { createFilteredQuotesLookup } from '../function/create-filtered-quotes-lookup.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { SelectQuotes } from './select-quotes.action';

export function selectQuotesReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__SELECT_QUOTES,
        SelectQuotes
    >,
): TranscriptDialogState {
    try {
        let nextSelected: TranscriptEntry[] = null;
        if (action.payload.mode === 'toggle-all') {
            // in this case, if the filter changed after it gets here... this will ignore previously selected items
            nextSelected =
                state.selectedQuotes?.length === state.filteredQuotes.length
                    ? []
                    : [...state.filteredQuotes];
        } else if (action.payload.mode === 'set') {
            nextSelected = action.payload.quotes;
        } else {
            nextSelected =
                state.selectedQuotes != null ? [...state.selectedQuotes] : [];
            action.payload.quotes.forEach((e) => {
                const index = nextSelected.indexOf(e);
                if (index === -1) {
                    nextSelected.push(e);
                } else {
                    nextSelected.splice(index, 1);
                }
            });
        }

        const { lookup: nextLookup, all: nextAllQuotesAreSelected } =
            createFilteredQuotesLookup(state.filteredQuotes, nextSelected);

        return {
            ...state,
            selectedQuotes: nextSelected,
            filteredQuotesSelectedLookup: nextLookup,
            allQuotesAreSelected: nextAllQuotesAreSelected,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
